'use client';

import { Nullable } from '@/components/types';
import { LegacyServerData } from '@/types/legacyServerData';
import React, { useContext } from 'react';

export type LegacyServerDataProviderProps = {
  legacyServerData: LegacyServerData | undefined;
  children: React.ReactNode;
};

export const LegacyServerContextData = React.createContext<Nullable<LegacyServerData>>(null);

export const LegacyServerDataProvider: React.FC<LegacyServerDataProviderProps> = ({
  legacyServerData,
  children,
}) => {
  return (
    <LegacyServerContextData.Provider value={legacyServerData || null}>
      {children}
    </LegacyServerContextData.Provider>
  );
};

export const useLegacyServerData = () => {
  return useContext(LegacyServerContextData);
};
